module.exports = __webpack_public_path__ + "img/UTKODA-7.973158c7.jpg";